import { createSlice } from '@reduxjs/toolkit'

import {
  NOTIFICATION_CLEAR,
  NOTIFICATION_DISMISS,
  NOTIFICATION_SHOW,
} from './types'

const initialState = []

function filterNotifications(notifications, id) {
  return notifications.filter(notification => notification.id !== id)
}

function showNotification(state, { payload }) {
  const filteredNotifications = filterNotifications(state, payload.id)
  return [payload, ...filteredNotifications]
}

function dismissNotification(state, { payload }) {
  return filterNotifications(state, payload.id)
}

function clearNotifications() {
  return initialState
}

const notifications = createSlice({
  name: 'notifications',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(NOTIFICATION_CLEAR, clearNotifications)
      .addCase(NOTIFICATION_DISMISS, dismissNotification)
      .addCase(NOTIFICATION_SHOW, showNotification)
  },
})

export default notifications.reducer
